export const encode = (val: string) => {
    return encodeURIComponent(val);
};

// ToDo Add support for param of type array
export interface IParams {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: string | Date | Record<string, any> | URLSearchParams;
}
export const buildUrl = (url: string, params?: IParams, paramsSerializer?: Function) => {
    if (!params) {
        return url;
    }

    let serializedParams;
    if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
    } else if (typeof URLSearchParams !== 'undefined' && params instanceof URLSearchParams) {
        serializedParams = params.toString();
    } else {
        const parts: string[] = [];

        Object.keys(params).forEach((key: string) => {
            let val = params[key];
            if (val === null || !val) {
                return;
            }
            if (val instanceof Date) {
                val = val.toISOString();
            } else if (val !== null && typeof val === 'object') {
                val = JSON.stringify(val);
            }
            parts.push(`${encode(key)}=${encode(<string>val)}`);
        });

        serializedParams = parts.join('&');
    }

    if (serializedParams) {
        return `${url}${url.indexOf('?') === -1 ? '?' : '&'}${serializedParams}`;
    }

    return url;
};
